import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import moment from 'moment';

const getSpanColor = (status: string) => {
  switch (status) {
    case '未投票':
      return '#CC771C';
    case '已截止':
      return '#A83C38';
    default:
      return '#103F60';
  }
};

const VoteListCell: React.FC<{
  title: string;
  status: string;
  expireTime: string;
  buildTime: string;
  voteType: string;
  currentIndex: number;
  onClick: () => void;
}> = ({
  title,
  status,
  expireTime,
  buildTime,
  onClick,
  voteType,
  currentIndex,
}) => {
  const showStatus = useMemo(() => {
    if (status === '未投票' && moment(expireTime).isBefore(moment())) {
      return '已截止';
    } else {
      return status;
    }
  }, [expireTime, status]);
  return (
    <Box
      sx={{
        py: '5vw',
        display: 'flex',
        flexDirection: 'column',
        '& > *:not(:last-child)': {
          mb: '0.7vw',
        },
      }}
      onClick={onClick}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          '@media (orientation: landscape)': {
            flexDirection: 'column-reverse',
            alignItems: 'flex-start',
          },
        }}
      >
        <Typography
          sx={{
            fontSize: '1.5em',
            lineHeight: '1.5em',
          }}
        >
          {title}
        </Typography>
        <Box
          sx={{
            backgroundColor: getSpanColor(showStatus),
            borderRadius: '0.28em',
            height: '1.7em',
            width: '4.3em',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              fontSize: '1em',
              lineHeight: '1em',
              color: '#FFFFFF',
            }}
          >
            {showStatus}
          </Typography>
        </Box>
      </Box>
      <Typography
        sx={{
          fontSize: '1.2em',
          lineHeight: '1.5em',
          color: '#A85B5B',
        }}
      >
        {`截止時間：${expireTime || '無'}`}
      </Typography>
      <Typography
        sx={{
          fontSize: '1.2em',
          lineHeight: '1.5em',
        }}
      >
        {`投票時間：${buildTime || '無'}`}
      </Typography>
      {currentIndex === 2 && (
        <Typography
          sx={{
            fontSize: '1.2em',
            lineHeight: '1.5em',
          }}
        >
          {`投票限制：${voteType}`}
        </Typography>
      )}
    </Box>
  );
};

export default VoteListCell;
